__turbopack_context__.v({
  "drawer_header": "header_menu-module-scss-module__WlsktG__drawer_header",
  "header_menu": "header_menu-module-scss-module__WlsktG__header_menu",
  "header_menu_item": "header_menu-module-scss-module__WlsktG__header_menu_item",
  "header_menu_left": "header_menu-module-scss-module__WlsktG__header_menu_left",
  "header_menu_link": "header_menu-module-scss-module__WlsktG__header_menu_link",
  "header_menu_right": "header_menu-module-scss-module__WlsktG__header_menu_right",
  "header_menu_separator": "header_menu-module-scss-module__WlsktG__header_menu_separator",
  "header_menu_wrapper": "header_menu-module-scss-module__WlsktG__header_menu_wrapper",
  "header_menu_wrapper_mobile": "header_menu-module-scss-module__WlsktG__header_menu_wrapper_mobile",
  "menu": "header_menu-module-scss-module__WlsktG__menu",
  "visible": "header_menu-module-scss-module__WlsktG__visible",
});
